<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g :fill="color">
        <g>
          <g>
            <path
              d="M15.5 9c.245 0 .45.177.492.41L16 9.5v6c0 .245-.177.45-.41.492L15.5 16H.5c-.245 0-.45-.177-.492-.41L0 15.5v-6c0-.245.177-.45.41-.492L.5 9h15zm-.5 1H1v5h14v-5zm-8.5 2c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L6.5 13h-3c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L3.5 12h3zm6 0c.276 0 .5.224.5.5s-.224.5-.5.5-.5-.224-.5-.5.224-.5.5-.5zm3-12c.245 0 .45.177.492.41L16 .5v6c0 .245-.177.45-.41.492L15.5 7H.5c-.245 0-.45-.177-.492-.41L0 6.5v-6C0 .255.177.05.41.008L.5 0h15zM15 1H1v5h14V1zM6.5 3c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L6.5 4h-3c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L3.5 3h3zm6 0c.276 0 .5.224.5.5s-.224.5-.5.5-.5-.224-.5-.5.224-.5.5-.5z"
              transform="translate(-24 -212) translate(0 196) translate(24 16)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'ServerIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
    color: VueTypes.string.def('#6783B2')
  }
};
</script>

<style lang="scss"></style>
